import HomeIcon from './HomeIcon';

export default HomeIcon;
